import React from 'react';

import { Box } from '@chakra-ui/react';
import { InputAdornment, TextField } from '@material-ui/core';
import { CustomTooltipComp } from 'screens/admin/common/TemplateCommons/QuestionListSidepanel/QuestionRow';
import TemplateQuestionAction from 'screens/admin/common/TemplateCommons/TemplateQuestionAction';
import styled from 'styled-components';
import { Divider1, StyledBox, StyledGrid, StyledPaper, StyledTooltip } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import theme from 'constants/theme';

import { Typography1 } from 'uiToolkit/Typography';

import DummyAnswerOptions from './DummyAnswerOptions';

const QuestionRowType2 = ({
  questionObject,
  handleRemoveQuestion,
  questionOrderChangeHandler,
  addQuestionHandler,
  handleQuestionDataChange,
  isLastItem,
  isFirstItem,
  index,
  selectedId,
  handleQuestionSelect,
}) => {
  const { question, weightage } = questionObject;
  const { providerToDescription, hasCustomDescription } = question;

  const handleMouseIn = () => {
    handleQuestionSelect(index);
  };
  const handleMouseOut = () => {
    handleQuestionSelect(null);
  };

  return (
    <ParentContainer flexcontainer onMouseEnter={handleMouseIn} onMouseLeave={handleMouseOut}>
      <StyledPaper
        elevation={0}
        padding="1rem"
        bottomGutter={2}
        flexgrow="1"
        border={selectedId === index ? theme.palette.borders.blue : theme.palette.borders.lighterGrey}
      >
        <StyledGrid padding="1rem" container>
          <StyledGrid item xs={12} bottomGutter={4}>
            {question.description}
            <br />
            {hasCustomDescription && providerToDescription && (
              <StyledTooltip title={<CustomTooltipComp providerToDescription={providerToDescription} />}>
                <Box cursor="pointer" textDecoration="underline" width="max-content" _hover={{ color: 'brand.blue' }}>
                  Variants applicable
                </Box>
              </StyledTooltip>
            )}
          </StyledGrid>
          <StyledGrid item xs={12} bottomGutter={4}>
            <DummyAnswerOptions question={question} />
          </StyledGrid>
          {question.analyticsQuestionType === 'RATING' ? (
            <StyledGrid item xs={12} bottomGutter={2}>
              <StyledDimBox flexcontainer justifycontent="flex-start" alignitems="center">
                <StyledTextField
                  value={weightage}
                  onChange={(e) =>
                    handleQuestionDataChange({
                      param: 'weightage',
                      value: e.target.value,
                      index,
                    })
                  }
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <Typography1 variant="caption" color="textSecondary">
                        %
                      </Typography1>
                    ),
                    startAdornment: (
                      <InputAdornment filled position="start">
                        <RightBorderedBox>
                          <Typography1 variant="caption" color="textSecondary" rightGutter={1}>
                            Weightage
                          </Typography1>
                        </RightBorderedBox>
                      </InputAdornment>
                    ),
                  }}
                />
              </StyledDimBox>
            </StyledGrid>
          ) : null}
        </StyledGrid>
        <StyledGrid padding="0.5rem" item xs={4}>
          {question.enableFeedbackText && (
            <FeedbackTextField variant="outlined" fullWidth placeholder="Short text answer" />
          )}
        </StyledGrid>
      </StyledPaper>
      {selectedId === index && (
        <MenuContainer>
          <TemplateQuestionAction
            handleAddQuestionClick={addQuestionHandler}
            handleChangeOrder={questionOrderChangeHandler}
            handleRemoveQuestion={handleRemoveQuestion}
            handleQuestionDataChange={handleQuestionDataChange}
            questionIndex={index}
            isRequired={questionObject.isRequired}
            isLastQuestion={isLastItem}
          />
        </MenuContainer>
      )}
      <Divider1 topGutter={1} />
    </ParentContainer>
  );
};

export default QuestionRowType2;

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-input {
    padding: 5px 10px;
  }
  height: 40px;
  width: 20ch;
  .MuiInputBase-root {
    height: 40px;
    width: 20ch;
  }
`;

const StyledDimBox = styled(StyledBox)`
  height: 100%;
  width: 100%;
`;

const RightBorderedBox = styled(StyledBox)`
  border-right: 1px solid ${getColorFromKey('lightGrey')};
`;

const MenuContainer = styled.div`
  position: absolute;
  right: -110px;
  width: 110px;
  height: calc(100% - 1rem);
  display: flex;
  align-items: center;
`;

const ParentContainer = styled(StyledBox)`
  position: relative;
  min-height: 200px;
  padding-right: 10px;
  background: none;
`;

const FeedbackTextField = styled(TextField)`
  .MuiInputBase-root {
    height: calc(3.5rem + 16px);
    font-size: 14px;
    margin-left: 5px;
  }
  .MuiOutlinedInput-input {
    padding: 0px 0px 2.3rem 0.75rem;
  }
`;
